import React from 'react';
import {Nav} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useTranslation } from 'react-i18next';
import createUUID from '../util/createUUID';

const LinksSecondary = (props) => {
    const { t } = useTranslation();

    const links = [
        {
            children: t(`Links.provider-acceptance-terms`),
            to: '/provider-acceptance-terms'
        },
        // {
        //     children: t(`Links.cookies-policy`),
        //     to: '/cookies-policy'
        // },
        {
            children: t(`Links.privacy-policy`),
            to: '/privacy-policy'
        },
        {
            children: t(`Links.contact-us`),
            to: '/contact-us'
        },
        // {
        //     children: t(`Links.sitemap`),
        //     to: '/sitemap'
        // },
    ]

    const linksFragment = [];

    for (const link of links) { 
        linksFragment.push((
            <LinkContainer
                key={createUUID()}
                to={link.to}
                exact={true}
                className='LinksSecondary--link'
                style={
                    {
                        flexGrow: 2,
                        flexShrink: 0,
                        padding: '0.5rem 1.1rem',
                    }
                }
            >
                <Nav.Link active={false}>{link.children}</Nav.Link>
            </LinkContainer>
        ))
    }

    return (<>
        <Nav className={props.className} style={{
            display: 'flex',
            flexBasis: 'max-content',
            flexWrap: 'wrap',
            alignContent: 'flex-start'
        }}>
            <style>
                {
                    `
                        .LinksSecondary--link {
                            flex-basis: auto;
                        }

                        @media(max-width: 60rem) {
                            .LinksSecondary--link {
                                flex-basis: 100%;
                                width: 100%;
                            }
                        }
                    `
                }
            </style>
            {linksFragment}
        </Nav>
    </>)
}

export default LinksSecondary;
